<div
  [class]="{
    'card-container': true,
    'email-modal': useEmailModal,
    'card-email-field': !useEmailModal && enableEmailForm,
    'email-disabled': !enableEmailForm && !useEmailModal,
  }"
>
  <div class="card-header">
    <div
      [class]="{
      'name-and-id-container': true,
      'sep': isSep,
      'oep': !isSep
    }"
    >
      <button
        (click)="renameQuote(applicationRecord)"
        class="quote-name-and-edit"
      >
        <span class="name"> {{ applicationRecord.statusDescription }} </span>
        <span class="material-symbols-outlined" click="">edit</span>
      </button>
      <div class="id">
        @if (isSep) {
          <app-sep-document-upload-status-indicator
            class="status-indicator"
            [applicationRecord]="applicationRecord"
            [quoteType]="quoteType"
          ></app-sep-document-upload-status-indicator>
        }
        @if (enrollmentFlow !== "sepPaper") {
          <span>{{ applicationRecord.applicationTrackingId }}</span>
        }
        <span class="app-type">{{ appType }}</span>
      </div>
    </div>
    <!-- EXPIRATION - bar format - used only in modal configuration-->
    @if (showExpiryNotice && useEmailModal) {
      <div
        class="expiry-warning email-modal"
        [class.expiry-soon]="daysUntilExpiration <= 7"
      >
        <span class="material-symbols-outlined">warning</span>Expires:
        {{ expirationDate }}
      </div>
    }
  </div>

  <!-- CONSUMER REFERRAL -->
  @if (enableEmailForm && !useEmailModal) {
    <div class="email-and-status-container">
      <form
        class="email-container"
        [formGroup]="emailForm"
        (submit)="triggerEmail(emailForm)"
      >
        <mat-form-field appearance="outline" class="email-form-field">
          <mat-label>{{ emailFieldLabel || "Customer Email Address" }}</mat-label>
          <input
            matInput
            formControlName="customerEmailAddress"
            [placeholder]="emailFieldPlaceholder"
          />
          @if (formControls.customerEmailAddress.errors) {
            <mat-error>
              @if (formControls.customerEmailAddress.errors.required) {
                <span>Required</span>
              }
              @if (formControls.customerEmailAddress.errors.maxlength) {
                <span>
                  Character limit:
                  {{ formControls.customerEmailAddress.errors?.maxlength.requiredLength }}
                  (Current:
                  {{ formControls.customerEmailAddress.errors?.maxlength.actualLength }})
                </span>
              } @else {
                @if (formControls.customerEmailAddress.errors.email) {
                  <span> Email format required: XXXX&#64;XXXX.XXXX </span>
                }
              }
            </mat-error>
          }
        </mat-form-field>

        <!-- (button) EMAIL -->
        @if (!emailTriggerIsPending) {
          <button
            mat-raised-button
            color="primary"
            type="submit"
            [disabled]="!emailForm?.valid"
          >
            {{ sendEmailButtonLabel || "Send" }}
          </button>
        } @else {
          <div class="pending-email-spinner">
            <mat-spinner [diameter]="30"></mat-spinner>
          </div>
        }
      </form>
    </div>
  }

  <div
    class="quote-plan-and-details-container"
    [class]="{
      'email-modal': useEmailModal && enableEmailForm,
      'card-email-field': !useEmailModal && enableEmailForm,
      'email-disabled': !enableEmailForm,
    }"
  >
    <div class="plan-name-container">
      <!-- (label) PLAN NAME-->
      <div class="info-heading">{{ planNameLabel }}</div>

      @if (applicationRecord.productName) {
        <!-- SINGLE PLAN-->
        <div class="plan-name">{{ applicationRecord.productName }}</div>
      } @else {
        <!-- COMPARE PLANS -->
        <div class="plan-name">Multiple Plans Selected</div>
      }
    </div>

    <div class="quote-details-container">

      <div class="quote-details-text">
        <div class="label">
          <span>{{ planMonthlyPremiumLabel || "Monthly Premium" }}:</span>
        </div>
        <div class="value">
          <span>{{ displayPremium }}</span>
        </div>
      </div>

      <div class="quote-details-text">
        <div class="label">
          <span>{{ planDeductibleLabel || "Yearly Deductible" }}:</span>
        </div>
        <div class="value">
          <span>{{ displayDeductible }}</span>
        </div>
      </div>

      <div class="quote-details-text">
        <div class="label">
          <span>{{ creationDateLabel }}:</span>
        </div>
        <div class="value">
          <span>{{ applicationRecord.creationDate | date: "MMM d, y" }}</span>
        </div>
      </div>

    </div>
  </div>

  <!-- PRODUCER DELETE / CONTINUE -->
  <div
    class="actions-container"
  >
  <!-- EXPIRATION - used only in non-modal configuration-->
    @if (showExpiryNotice && !useEmailModal) {
      <div
        class="expiry-warning no-email-modal"
        [class.expiry-soon]="daysUntilExpiration <= 7"
      >
        <span class="material-symbols-outlined">warning</span>Expires:
        {{ expirationDate }}
      </div>
    }
    <div
    [class.modal-actions-container]="useEmailModal"
    [class.card-field-actions-container]="!useEmailModal">
    <!-- (button) EMAIL QUOTE / OPEN MODAL -->
      @if (useEmailModal) {
        <div 
          [matTooltip]="disableReferralTooltip"
          matTooltipPosition="above"
          [matTooltipDisabled]="enableEmailForm"
        >
          <button
            mat-raised-button
            class="action-button"
            color="primary"
            (click)="openEmailReferralModal()"
            [disabled]="!enableEmailForm"
          >
            {{ sendEmailButtonLabel || "Email Quote" }}
          </button>
        </div>
      }

      <!-- (button) DELETE QUOTE -->
      <button
        mat-stroked-button
        class="action-button"
        [class.no-email-modal]="!useEmailModal"
        color="accent"
        (click)="deleteQuote()"
      >
        {{ deleteQuoteButtonLabel || "Delete Quote" }}
      </button>

      <!-- (button) CONTINUE QUOTE -->
      @if (!continueQuoteIsPending) {
        <button
          mat-raised-button
          class="action-button"
          [class.no-modal-continue-button]="!useEmailModal"
          color="primary"
          (click)="continueQuote(applicationRecord)"
        >
          {{ continueApplicationButtonLabel || "Continue Quote" }}
        </button>
      } @else {
        <div class="pending-spinner">
          <mat-spinner [diameter]="30"></mat-spinner>
        </div>
      }
    </div>
  </div>
</div>
